const chillout = require('chillout');

const SettingCatalogue = (callback) => {

    /**
     * スマホ用のカタログを生成
     */
    const images = document.getElementsByClassName('js-catalogue-img');
    const catalogueList = document.getElementById('js-catalogue-list');

    if (!catalogueList) return;

    chillout.forEach([...images], (elem, index) => {

        const clone = elem.cloneNode();

        clone.removeAttribute("id");

        const div = document.createElement('div');

        div.classList.add('catalogue-list__item');

        if (index === 0) {
            div.classList.add('catalogue-list__item--cover');
            div.id = 'js-cover';
            clone.id = 'js-sp-cover-img';
        }

        div.appendChild(clone);

        catalogueList.appendChild(div);

    }).then(() => {
        const catalogueTouchNav = document.createElement('div');
        catalogueTouchNav.classList.add('catalogue-both-slider');

        const touchNavLeft = document.createElement('div');
        touchNavLeft.classList.add('catalogue-both-slider__left');
        touchNavLeft.id = 'js-slider-prev';

        catalogueTouchNav.appendChild(touchNavLeft);

        const touchNavRight = document.createElement('div');
        touchNavRight.classList.add('catalogue-both-slider__right');
        touchNavRight.id = 'js-slider-next';

        catalogueTouchNav.appendChild(touchNavRight);

        catalogueList.appendChild(catalogueTouchNav);

        callback();
    });
}

export default SettingCatalogue;
